/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useRef } from "react";
import {
  CommonButton,
  ImageElement,
  ModalComponent,
  RippleEffect,
  Checkbox,
} from "components";
import {
  Button,
  Card,
  Col,
  Container,
  Nav,
  Navbar,
  Row,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import {
  // Navigation,
  Pagination,
  EffectCoverflow,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-coverflow";
import { Select, Upload } from "antd";
import routesMap from "routeControl/userRouteMap";
import { getSessionStorage, setSessionStorage } from "utils";

function Theme03Static() {
  const [isActive, setIsActive] = useState(false);
  const [isActiveMap, setIsActiveMap] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const oneSubscriptionData = getSessionStorage("oneSubscriptionData");

  const navigate = useNavigate();
  const path = {
    1: `${routesMap?.LAYOUTFOUR?.path}/${1}`,
    4: `${routesMap?.LAYOUTFOUR?.path}/${4}`,
    3: routesMap?.LAYOUTTHREE?.path,
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setIsActiveMap(false);
    };
    handleResize();
    // Add event listener for window resize
    window.addEventListener("resize", handleResize);
    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount
  const toggleClassMap = () => {
    if (windowWidth <= 991) {
      setIsActiveMap(!isActiveMap);
    }
  };
  const handleCloseMap = () => {
    setIsActiveMap(false);
  };
  //  header click section redirect function
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    let navbarMenu = document.querySelector(
      ".theme03Header .navbar"
    ).clientHeight;
    setOffset(navbarMenu);
  }, [window.scroll]);

  const toggleClass = () => {
    setIsActive(!isActive);
    document.querySelector("body").style.overflow = `hidden`;
  };
  const handleClose = () => {
    setIsActive(false);
    document.querySelector("body").style.overflow = `auto`;
  };

  const [leftPadding, setLeftPadding] = useState();
  const [scrolltopdata, setscrolltopdata] = useState("");
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY < 50) {
        setscrolltopdata("");
      } else {
        setscrolltopdata("navbar_scroll");
      }
    });
    const handleResize = () => {
      const containerOffset = document
        .querySelector(".container")
        .getBoundingClientRect();
      const newLeftPadding = containerOffset.left + 15;
      setLeftPadding(newLeftPadding);
    };
    handleResize();
    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [shareModal, setShareModal] = useState(false);
  const handleCloseModal = () => {
    setShareModal(false);
  };
  /* memeories video modal */
  const [showVideoModal, setVideoModal] = useState(false);
  const handleCloseModalVideo = () => {
    setVideoModal(false);
  };
  /* memeories full video modal */
  const [showVideoFullModal, setVideoFullModal] = useState(false);
  const handleCloseModalVideoFull = () => {
    setVideoFullModal(false);
    setVideoModal(true);
  };
  const handleVideoFullShow = () => {
    setVideoFullModal(true);
    setVideoModal(false);
  };
  /* memeories audio modal */
  const [showAudioModal, setAudioModal] = useState(false);
  const handleCloseModalAudio = () => {
    setAudioModal(false);
  };
  /* memeories pdf modal */
  const [showPdfModal, setPdfModal] = useState(false);
  const handleCloseModalPdf = () => {
    setPdfModal(false);
  };
  /* image slider modal */
  const [showModal1, setShowModal1] = useState(false);
  const handleCloseModal1 = () => {
    setShowModal1(false);
  };
  const openImageModal1 = () => {
    setShowModal1(!showModal1);
  };

  /* Comment Modal */
  const [commentModal, setCommentModal] = useState(false);
  const handleCloseModalComment = () => {
    setCommentModal(false);
  };
  /* report modal */
  const [showReportModal, setReportModal] = useState(false);
  const handleCloseModalReport = () => {
    setReportModal(false);
  };
  const [hoveredItem, setHoveredItem] = useState(2);
  // let intervalId;
  const imageItems = [
    { src: "theme03/user-img-01.webp", alt: "Image 1" },
    { src: "theme03/user-img-02.webp", alt: "Image 2" },
    { src: "theme03/user-img-03.webp", alt: "Image 3" },
    { src: "theme03/user-img-04.webp", alt: "Image 3" },
    { src: "theme03/user-img-05.webp", alt: "Image 3" },
    // Add more images as needed
  ];
  const handleMouseEnter = (index) => {
    setHoveredItem(index);
  };

  const handleMouseLeave = (index) => {
    if (hoveredItem === index) {
      setHoveredItem(null);
    }
  };



  const Navigation = () => {
    console.log("oneSubscriptionData", oneSubscriptionData);
    if (oneSubscriptionData && oneSubscriptionData?.memorialId === null) {
      navigate(path?.[oneSubscriptionData?.subscription?.layout]);
      setSessionStorage("oneSubscriptionData", oneSubscriptionData);
    } else {
      navigate(routesMap?.CHOOSE_PLAN?.path);
    }
  };
  const videoMemories = [
    {
      id: 1,
      name: "Friendship Chronicles",
      duration: "08:45",
      thumbnail: "modal-video-01.webp",
      alt: "",
    },
    {
      id: 2,
      name: "Love & Relationships",
      duration: "08:45",
      thumbnail: "modal-video-02.webp",
    },
    {
      id: 3,
      name: "Adventures in Youth",
      duration: "08:45",
      thumbnail: "modal-video-03.webp",
    },
    {
      id: 4,
      name: "Innocence Unveiled",
      duration: "08:45",
      thumbnail: "modal-video-04.webp",
    },
    {
      id: 5,
      name: "Teenage Dreams",
      duration: "08:45",
      thumbnail: "modal-video-05.webp",
    },
    {
      id: 6,
      name: "Friendship Chronicles",
      duration: "08:45",
      thumbnail: "modal-video-06.webp",
    },
  ];
  const audioMemories = [
    {
      id: 1,
      name: "Friendship Chronicles",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 2,
      name: "Journey of Love",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 3,
      name: "Innocence Unveiled",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 4,
      name: "Adventures in Youth",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 5,
      name: "Friendship Chronicles",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 6,
      name: "Journey of Love",
      audioUrl: "",
      duration: "09:45",
    },
  ];
  /* PDF Modal Select */
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [individualCheckboxes, setIndividualCheckboxes] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChange = (index) => {
    const updatedCheckboxes = [...individualCheckboxes];
    updatedCheckboxes[index] = !updatedCheckboxes[index];
    setIndividualCheckboxes(updatedCheckboxes);
    const allChecked = updatedCheckboxes.every((checkbox) => checkbox);
    setSelectAllChecked(allChecked);
  };
  const handleSelectAll = () => {
    const allChecked = !selectAllChecked;
    setSelectAllChecked(allChecked);
    setIndividualCheckboxes(Array(6).fill(allChecked));
  };
  /* audio Modal Select */
  const [selectAllCheckedAudio, setSelectAllCheckedAudio] = useState(false);
  const [individualCheckboxesAudio, setIndividualCheckboxesAudio] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChangeAudio = (index) => {
    const updatedCheckboxesAudio = [...individualCheckboxesAudio];
    updatedCheckboxesAudio[index] = !updatedCheckboxesAudio[index];
    setIndividualCheckboxesAudio(updatedCheckboxesAudio);
    const allCheckedAudio = updatedCheckboxesAudio.every(
      (checkbox) => checkbox
    );
    setSelectAllCheckedAudio(allCheckedAudio);
  };
  const handleSelectAllAudio = () => {
    const allCheckedAudio = !selectAllCheckedAudio;
    setSelectAllCheckedAudio(allCheckedAudio);
    setIndividualCheckboxesAudio(Array(6).fill(allCheckedAudio));
  };
  /* video Modal Select */
  const [selectAllCheckedVideo, setSelectAllCheckedVideo] = useState(false);
  const [individualCheckboxesVideo, setIndividualCheckboxesVideo] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChangeVideo = (index) => {
    const updatedCheckboxesVideo = [...individualCheckboxesVideo];
    updatedCheckboxesVideo[index] = !updatedCheckboxesVideo[index];
    setIndividualCheckboxesVideo(updatedCheckboxesVideo);
    const allCheckedVideo = updatedCheckboxesVideo.every(
      (checkbox) => checkbox
    );
    setSelectAllCheckedVideo(allCheckedVideo);
  };
  const handleSelectAllVideo = () => {
    const allCheckedVideo = !selectAllCheckedVideo;
    setSelectAllCheckedVideo(allCheckedVideo);
    setIndividualCheckboxesVideo(Array(6).fill(allCheckedVideo));
  };

  //  ********************* Family tree functions *************************
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    if (isFullscreen) document.exitFullscreen();
    else document.documentElement.requestFullscreen();
    setIsFullscreen((prevState) => !prevState);
  };

  function exitHandler() {
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setIsFullscreen(false);
    }
  }

  if (document.addEventListener) {
    document.addEventListener("fullscreenchange", exitHandler, false);
    document.addEventListener("mozfullscreenchange", exitHandler, false);
    document.addEventListener("MSFullscreenChange", exitHandler, false);
    document.addEventListener("webkitfullscreenchange", exitHandler, false);
  }

  let tree = document.querySelector(".parent");
  let eleWidth = document.querySelector(".tree");
  let screenWidthOut = eleWidth?.offsetWidth;
  let treeWidthOut = tree?.offsetWidth;
  let isDragging = false;
  let startX;
  let startY;
  let startLeft;
  let startTop;
  let zoomValue;
  if (treeWidthOut > screenWidthOut) {
    zoomValue = screenWidthOut / treeWidthOut;
  } else {
    zoomValue = 1;
  }
  function fitToScreen() {
    let screenWidth = eleWidth?.offsetWidth;
    let treeWidth = tree?.offsetWidth;
    if (treeWidth > screenWidth) {
      let scale = screenWidth / treeWidth;
      zoomValue = scale;
      if (tree) {
        tree.style.transform = `scale(${scale})`;
      }
      tree.style.top = "auto";
      tree.style.left = "auto";
    } else {
      if (tree) {
        tree.style.transform = "scale(1)";
        tree.style.top = "auto";
        tree.style.left = "auto";
      }
    }
  }

  function zoomIn() {
    if (zoomValue < 2) {
      zoomValue += 0.1;
      tree.style.transform = `scale(${zoomValue})`;
    }
  }
  function zoomOut() {
    if (zoomValue > 0.16) {
      zoomValue -= 0.1;
      tree.style.transform = `scale(${zoomValue})`;
    }
  }
  tree?.addEventListener("mousedown", function (event) {
    isDragging = true;
    startX = event.clientX;
    startY = event.clientY;
    startLeft = parseInt(tree?.style.left) || 0;
    startTop = parseInt(tree?.style.top) || 0;
    tree.classList.add("noselect");
    tree.style.cursor = "grabbing";
  });
  tree?.addEventListener("touchstart", function (event) {
    isDragging = true;
    const touchLocation = event.targetTouches[0];
    startX = touchLocation.pageX;
    startY = touchLocation.pageY;
    startLeft = parseInt(tree?.style.left) || 0;
    startTop = parseInt(tree?.style.top) || 0;
    tree.classList.add("noselect");
    tree.style.cursor = "grabbing";
  });

  document.addEventListener("mouseup", function () {
    isDragging = false;
    if (tree) {
      tree.classList.remove("noselect");
      tree.style.cursor = "grab";
    }
  });
  document.addEventListener("touchend", function () {
    isDragging = false;
    if (tree) {
      tree.classList.remove("noselect");
      tree.style.cursor = "grab";
    }
  });

  document.addEventListener("mousemove", function (event) {
    if (isDragging) {
      let offsetX = event.clientX - startX;
      let offsetY = event.clientY - startY;
      if (tree) {
        tree.style.left = `${startLeft + offsetX}px`;
        tree.style.top = `${startTop + offsetY}px`;
      }
    }
  });
  document.addEventListener("touchmove", function (event) {
    if (isDragging) {
      const touchLocation = event.targetTouches[0];
      let offsetX = touchLocation.pageX - startX;
      let offsetY = touchLocation.pageY - startY;
      if (tree) {
        tree.style.left = `${startLeft + offsetX}px`;
        tree.style.top = `${startTop + offsetY}px`;
      }
    }
  });
  tree?.addEventListener("wheel", function (event) {
    event.preventDefault();
    if (event.deltaY < 0) {
      zoomIn();
    } else {
      zoomOut();
    }
  });
  tree?.addEventListener(
    "gestureend",
    function (e) {
      e.preventDefault();
      if (e.scale < 1.0) {
        zoomOut();
      } else if (e.scale > 1.0) {
        zoomIn();
      }
    },
    false
  );
  window.addEventListener("resize", fitToScreen);
  useEffect(() => {
    fitToScreen();
  }, [tree]);

  const treeHeightRef = useRef(null);
  useEffect(() => {
    if (treeHeightRef.current) {
      const treeHeight = treeHeightRef.current.offsetHeight;
      let sheet = document.styleSheets[0];
      sheet.insertRule(`:root{--treeHeightRef:${treeHeight}px}`);
    }
  }, []);

  return (
    <>
      {/* Header Start */}
      <header className="theme03Header">
        <Navbar fixed="top" expand={false} className={`${scrolltopdata}`}>
          <Container className="d-block">
            <div className="d-flex align-items-center justify-content-between">
              <Navbar.Brand
                href={routesMap.USERDASHBOARD.path}
                className="navbar-brand flex-grow-1 flex-lg-grow-0 p-0"
              >
                <ImageElement
                  source="theme-logo.svg"
                  className="lightLogo"
                  alt="logo"
                />
                <ImageElement
                  source="logo.svg"
                  className="darkLogo"
                  alt="logo"
                />
              </Navbar.Brand>
              <div className={`overlay ${isActive ? "open" : ""}`}>
                <div className="layout d-flex flex-column">
                  <div className="d-flex justify-content-between">
                    <Navbar.Brand
                      href={routesMap.USERDASHBOARD.path}
                      className="navbar-brand flex-grow-1 flex-lg-grow-0 p-0"
                    >
                      <ImageElement
                        source="theme-logo.svg"
                        className=""
                        alt="logo"
                      />
                    </Navbar.Brand>
                    <Link to="#" onClick={handleClose} className="close-button">
                      <div className="in">
                        <div className="close-button-block" />
                        <div className="close-button-block" />
                      </div>
                      <div className="out">
                        <div className="close-button-block" />
                        <div className="close-button-block" />
                      </div>
                    </Link>
                  </div>
                  <div className="menuLinks">
                    <Nav className="d-flex flex-grow-1 overlay--menu">
                      <ScrollLink
                        activeClass="active"
                        className="nav-link"
                        to="about"
                        spy
                        smooth
                        offset={-offset}
                        duration={800}
                        onClick={handleClose}
                      >
                        <p className="link">About</p>
                        <span className="clickLink">Click Here</span>
                      </ScrollLink>
                      <ScrollLink
                        activeClass="active"
                        className="nav-link"
                        to="gallery"
                        spy
                        smooth
                        offset={-offset}
                        duration={800}
                        onClick={handleClose}
                      >
                        <p className="link">Gallery</p>
                        <span className="clickLink">Click Here</span>
                      </ScrollLink>
                      <ScrollLink
                        activeClass="active"
                        className="nav-link"
                        to="timeline"
                        spy
                        smooth
                        offset={-offset}
                        duration={800}
                        onClick={handleClose}
                      >
                        <p className="link">Timeline</p>
                        <span className="clickLink">Click Here</span>
                      </ScrollLink>
                      <ScrollLink
                        activeClass="active"
                        className="nav-link"
                        to="story"
                        spy
                        smooth
                        offset={-offset}
                        duration={800}
                        onClick={handleClose}
                      >
                        <p className="link">Story</p>
                        <span className="clickLink">Click Here</span>
                      </ScrollLink>
                      <ScrollLink
                        activeClass="active"
                        className="nav-link"
                        to="familytree"
                        spy
                        smooth
                        offset={-offset}
                        duration={800}
                        onClick={handleClose}
                      >
                        <p className="link">Family Tree</p>
                        <span className="clickLink">Click Here</span>
                      </ScrollLink>
                    </Nav>
                  </div>
                  <ul className="list-unstyled d-sm-flex social flex-shrink-0 position-relative justify-content-center">
                    <li>
                      <Link aria-label="facebook">
                        Instagram <em className="icon-arrow-right" />
                      </Link>
                    </li>
                    <li>
                      <Link aria-label="twitter">
                        Twitter <em className="icon-arrow-right" />
                      </Link>
                    </li>
                    <li>
                      <Link aria-label="facebook">
                        Facebook <em className="icon-arrow-right" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <Navbar.Toggle
                  aria-controls="basic-navbar-nav"
                  className={`menuIcon bg-transparent btn open-menu ${isActive ? "active" : ""
                    }`}
                  onClick={toggleClass}
                >
                  <span>Menu</span>
                  <em className="icon-dots ms-sm-2 d-none d-sm-block" />
                </Navbar.Toggle>
                <RippleEffect extraClassName="btnCenter">
                  <CommonButton className="btn-gradiant btn-gradiant-white position-relative">
                    <em className="icon-saved me-sm-2" />
                    <span className="d-none d-sm-block">Save</span>
                  </CommonButton>
                </RippleEffect>
                <RippleEffect extraClassName="btnCenter">
                  <CommonButton
                    className="btn-gradiant"
                    onClick={() => setShareModal(true)}
                  >
                    <em className="icon-share me-sm-2" />
                    <span className="d-none d-sm-block">Share</span>
                  </CommonButton>
                </RippleEffect>
                <RippleEffect extraClassName="btnCenter">

                  <CommonButton
                    onClick={(e) => {
                      e.preventDefault();
                      Navigation();
                    }}
                    className="btn-gradiant btn-gradiant-white position-relative backBtn"
                  >
                    <em className="icon-arrow-prev me-sm-2" />
                    <span className="d-none d-sm-block">Back</span>
                  </CommonButton>
                </RippleEffect>
                {/* <RippleEffect extraClassName="btnCenter">
                  <CommonButton
                    className="btn-gradiant btn-gradiant-white position-relative"
                  >
                    <em className="icon-edit me-sm-2" />
                    <span className="d-none d-sm-block">Edit</span>
                  </CommonButton>
                </RippleEffect>
                <RippleEffect>
                  <CommonButton
                    className="btn-gradiant w-auto"
                  >
                    <span>Publish</span>
                  </CommonButton>
                </RippleEffect> */}
              </div>
            </div>
          </Container>
        </Navbar>
      </header>
      {/* Header End */}
      <main className="theme03Page">
        {/* Banner Start */}
        <div className="banner position-relative overflow-hidden">
          <div className="banner_inner">
            <Container>
              <div className="head text-center">
                <h1 className="text-white">Margarita R. Proffitt</h1>
                <p>Jan 10, 1970 - Aug 12, 2024</p>
                <p>
                  <em className="icon-location me-2" />
                  Los Angeles, US
                </p>
              </div>
            </Container>
            <div className="imageList">
              <ul className="list-unstyled mb-0 d-flex justify-content-center">
                {imageItems.map((item, index) => (
                  <li key={index}>
                    <ImageElement
                      className={`object-fit-cover img-fluid ${hoveredItem === index ? "active" : ""
                        }`}
                      source={item.src}
                      alt={item.alt}
                      onMouseEnter={() => handleMouseEnter(index)}
                      onMouseLeave={handleMouseLeave}
                    />
                  </li>
                ))}
                {/* <li>
                    <ImageElement
                      className="object-fit-cover img-fluid"
                      source="theme03/user-img-02.webp"
                    />
                  </li>
                  <li>
                    <ImageElement
                      className="object-fit-cover img-fluid"
                      source="theme03/user-img-01.webp"
                    />
                  </li>
                  <li>
                    <ImageElement
                      className="object-fit-cover img-fluid"
                      source="theme03/user-img-04.webp"
                    />
                  </li>
                  <li>
                    <ImageElement
                      className="object-fit-cover img-fluid"
                      source="theme03/user-img-05.webp"
                    />
                  </li> */}
              </ul>
            </div>
            <div className="py-80 pt-0 circle">
              <Container>
                <div className="banner_bottom text-center">
                  <h2 className="text-uppercase">
                    The Untold <br className="d-none d-lg-block" />
                    Journey{" "}
                  </h2>
                  <p className="mb-0">
                    Margarita Rose Proffitt, a luminary born into the world on
                    the balmy afternoon of September 19, 1990, brought her
                    unique brilliance to every corner of life. From her early
                    days in the vibrant city of Harmonyville, Margarita
                    demonstrated an indomitable spirit and an unwavering
                    commitment to spreading joy.
                  </p>
                  {/* <div className="d-flex justify-content-center">
                      <RippleEffect>
                        <Button className="btn btn-gradiant btnDownload">
                          <em className="icon-download" />
                          <span className="d-none d-sm-block">Download</span>
                        </Button>
                      </RippleEffect>
                    </div> */}
                </div>
              </Container>
            </div>
          </div>
        </div>
        {/* Banner End */}
        <section className="aboutSecDetail py-80" id="about">
          <Container>
            <div className="aboutSecDetail_inner position-relative">
              <div className="d-flex justify-content-between">
                <h3 className="mb-0">About</h3>
                <div className="aboutSecDetail_socialmedia">
                  <ul className="list-unstyled mb-0 d-flex">
                    <li>
                      <Link
                        to="#"
                        className="d-flex justify-content-center align-items-center"
                        aria-label="instagram"
                      >
                        {" "}
                        <em className="icon-instagram" />{" "}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="d-flex justify-content-center align-items-center"
                        aria-label="twitter"
                      >
                        {" "}
                        <em className="icon-twitter" />{" "}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="d-flex justify-content-center align-items-center"
                        aria-label="facebook"
                      >
                        {" "}
                        <em className="icon-facebook" />{" "}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                        aria-label="report"
                        onClick={() => setReportModal(true)}
                      >
                        <em className="icon-report" />
                      </Link>
                      {/* <Dropdown className="d-flex justify-content-center align-items-center">
                          <Dropdown.Toggle className="aboutSecDetail_social_icon p-0 border-0">
                            <em className="icon-more-vertical" />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="border-0 p-0">
                            <Dropdown.Item href="#/action-1">
                              Report User
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown> */}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="aboutSecDetail_list">
                <Row>
                  <Col md={6} sm={12}>
                    <div className="aboutSecDetail_listleft">
                      <ul className="list-unstyled mb-0">
                        <li className="d-flex">
                          <span>Born</span>: September 21 ,1985 Los Angeles, US
                        </li>
                        <li className="d-flex">
                          <span>Birth Place</span>: Los Angeles, United States
                        </li>
                        <li className="d-flex">
                          <span>Spouse</span>: Terry A. Perkins (m. 2014)
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col md={6} sm={12}>
                    <div className="aboutSecDetail_listright">
                      <ul className="list-unstyled mb-0">
                        <li className="d-flex">
                          <span>Parents</span>: Robert C.McCormick, Kasandra J.
                          McCormick
                        </li>
                        <li className="d-flex">
                          <span>Children</span>: Kevin J. Perkins, Andrew J.
                          Perkins
                        </li>
                        <li className="d-flex">
                          <span>Siblings</span>: Mallory A. McCormick
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Container>
        </section>

        <section className="biographySec py-80">
          <Container>
            <Row>
              <Col md={6} sm={12}>
                <div className="commonHead mb-0">
                  <h2 className="commonHead_title mb-0">
                    Lorem Ipsum Is Simply Dummy Text Of The Printing And
                    Typesetting Industry.
                  </h2>
                </div>
              </Col>
              <Col md={6} sm={12}>
                <p>
                  Margarita R. Proffitt, a trailblazing figure in the field of
                  environmental science, has devoted her life to the pursuit of
                  sustainable practices and ecological conservation. Born and
                  raised in the picturesque landscapes of the Pacific Northwest,
                  Barbara developed an early fascination with the delicate
                  balance of nature.
                </p>
                <p>
                  Beyond her academic achievements, Margarita's impact extends
                  to her active involvement in environmental advocacy. She has
                  been a vocal proponent of sustainable policies and has lent
                  her expertise to various conservation initiatives.
                </p>
              </Col>
            </Row>
          </Container>
          <div className="downloadSec">
            <Container>
              <div className="downloadSec_inner rounded-0">
                <Row className="justify-content-md-between">
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard storyCard-theme03">
                      <div
                        className="storyCard_img position-relative storyCard_img-audio cursor-pointer"
                        onClick={() => setAudioModal(true)}
                      >
                        <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center">
                          <em className="icon-mic" />
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">Audio</h2>
                    </div>
                  </Col>
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard storyCard-theme03">
                      <div
                        className="storyCard_img position-relative videoImg storyCard_img-image cursor-pointer"
                        onClick={() => setVideoModal(true)}
                      >
                        <div className="image">
                          <ImageElement
                            className="img-fluid w-100 h-100 object-fit-cover"
                            source="downloadable-img .webp"
                          />
                        </div>
                        <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center">
                          <em className="icon-img-video" />
                        </div>
                        {/* <div
                          className="storyCard_btn position-absolute d-flex justify-content-center align-items-center"
                          onClick={() => setVideoModal(true)}
                        >
                          <em className="icon-video" />
                        </div> */}
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">
                        Image & Video
                      </h2>
                    </div>
                  </Col>
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard storyCard-theme03">
                      <div
                        className="storyCard_img position-relative storyCard_img-pdf cursor-pointer"
                        onClick={() => setPdfModal(true)}
                      >
                        <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center">
                          <em className="icon-pdf" />
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">PDF</h2>
                    </div>
                  </Col>
                  <Col xxl={4} md={3} sm={6} xs={6}>
                    <div className="d-flex h-100 flex-column justify-content-center storyCnt">
                      <h2>Downloadable Memories</h2>
                      <p className="mb-1 ps-0">
                        Sharing a life legacy for generations to come.
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
        </section>

        {/* lankmark section */}
        <section
          className={`landmarkSec d-block justify-content-between position-relative ${isActiveMap ? "active" : ""
            }`}
        >
          <div
            className="landmarkSec_left py-80"
            style={{ paddingLeft: leftPadding }}
          >
            <div className="commonHead mb-0">
              <div className="commonHead_sub">
                Click an image to view a timeless memory
              </div>
              <h2 className="commonHead_title text-white">
                Timeless Memories and <br className="d-none d-xxl-block" />{" "}
                Memorial Places{" "}
              </h2>
            </div>
            {/* <ul className="list-unstyled mb-0">
              <li className="count">
                <h2 className="text-white">48</h2>
                <p className="text-uppercase">Memorial Places</p>
              </li>
              <li className="count">
                <h2 className="text-white">12</h2>
                <p className="text-uppercase">visited countries</p>
              </li>
            </ul> */}
          </div>
          <div className="landmarkSec_right" onClick={toggleClassMap}>
            <div className="mapOverlay" />
            <ImageElement
              className="img-fluid w-100 h-100 object-fit-cover"
              source="theme03/theme03-map.webp"
            />
            <div className="landmarkSec_box">
              <Card className="position-relative">
                <Link className="closeBtn" onClick={handleCloseMap}>
                  <em className="icon-close" />
                </Link>
                <Card.Header className="bg-white">
                  <div className="profileImg d-flex align-items-center">
                    <ImageElement
                      className="img-fluid w-100 h-100 object-fit-cover"
                      source="theme03/theme03-map-detail.webp"
                    />
                  </div>
                </Card.Header>
                <Card.Body className="bg-white">
                  <span className="d-block date">20 Feb 2023</span>
                  <h3>Friendship Saga, Journeying Through Bonds</h3>
                  <span className="d-block location">
                    <em className="icon-location me-1" />
                    San Francisco, CL
                  </span>
                  <div className="content">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled .
                    </p>
                  </div>
                </Card.Body>
                <Card.Footer className="bg-white d-flex justify-content-between align-items-end count">
                  <div className="me-1 count_txt">
                    <span>1 </span>/ 12
                  </div>
                  <div className="flex-shrink-0">
                    <RippleEffect>
                      <Button
                        type="button"
                        className="btn btn-light count_btn me-2 me-lg-3"
                      >
                        <em className="icon-arrow-right count_btn_arrowLeft" />
                      </Button>
                    </RippleEffect>
                    <RippleEffect>
                      <Button
                        type="button"
                        className="btn btn-danger count_btn"
                      >
                        <em className="icon-arrow-right" />
                      </Button>
                    </RippleEffect>
                  </div>
                </Card.Footer>
              </Card>
            </div>
          </div>
        </section>
        {/* lankmark section */}

        {/* captured section */}
        <section className="preservingSec py-80 light-bg" id="gallery">
          <Container>
            <div className="commonHead text-center">
              <div className="commonHead_sub">
                Photographs- Videos- Other Media
              </div>
              <h2 className="commonHead_title">Captured Memories</h2>
            </div>
            <div className="preservingSec_inner">
              <Row>
                <Col xs={6} sm={6} md={4}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_img">
                      <ImageElement
                        className="object-fit-cover w-100 h-100"
                        source="theme03/preserving-01.webp"
                      />
                    </div>
                    <h4>
                      The Early <br className="d-none d-lg-block" />
                      Years
                    </h4>
                  </div>
                </Col>
                <Col xs={6} sm={6} md={4}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_img">
                      <ImageElement
                        className="object-fit-cover w-100 h-100"
                        source="theme03/preserving-02.webp"
                      />
                    </div>
                    <h4>
                      Footprints
                      <br className="d-none d-lg-block" /> of Time
                    </h4>
                  </div>
                </Col>
                <Col xs={6} sm={6} md={4}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_img">
                      <ImageElement
                        className="object-fit-cover w-100 h-100"
                        source="theme03/preserving-03.webp"
                      />
                    </div>
                    <h4>
                      Love & <br className="d-none d-lg-block" />
                      Relationships
                    </h4>
                  </div>
                </Col>
                <Col xs={6} sm={6} md={4}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_img">
                      <ImageElement
                        className="object-fit-cover w-100 h-100"
                        source="theme03/preserving-04.webp"
                      />
                    </div>
                    <h4>
                      Friendship <br className="d-none d-lg-block" />
                      Chronicles
                    </h4>
                  </div>
                </Col>
                <Col xs={6} sm={6} md={4}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_img">
                      <ImageElement
                        className="object-fit-cover w-100 h-100"
                        source="theme03/preserving-05.webp"
                      />
                    </div>
                    <h4>
                      Home Sweet <br className="d-none d-lg-block" />
                      Home
                    </h4>
                  </div>
                </Col>
                <Col xs={6} sm={6} md={4}>
                  <div className="box" onClick={() => openImageModal1()}>
                    <div className="box_img">
                      <ImageElement
                        className="object-fit-cover w-100 h-100"
                        source="theme03/preserving-06.webp"
                      />
                    </div>
                    <h4>
                      Special <br className="d-none d-lg-block" />
                      Occasions
                    </h4>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        {/* captured section */}

        {/* theme03 family tree section */}
        {/* <section
          className={` familyTree py-80 theme03 bg-white ${isFullscreen ? "fullWidth" : ""
            }`}
          id="familytree"
        >
          <div className="commonHead text-center">
            <div className="commonHead_sub">The Legacy Lives On</div>
            <h2 className="commonHead_title">Our Family Tree</h2>
          </div>
          <div className="familyTreeContainer mx-auto">
            <div className="tree">
              <ul className="tree_inner">
                <li className="parent">
                  <div className="d-flex align-items-end parentsWrap  justify-content-center">
                    <div className="spouseParents">
                      <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                        <div className="grandParents_item">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="grandParents_item ">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>M G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>M G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <ul>
                        <li className="child">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user27.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>-</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user12.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>-</p>
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="mainParents">
                      <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                        <div className="grandParents_item">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="grandParents_item ">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>M G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>M G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <ul>
                        <li className="child">
                          <a href="#!" className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user15.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G Mother</h2>
                                <p>May 1961 - Dec 2022</p>
                                <p>-</p>
                              </div>
                            </div>
                          </a>
                          <a href="#!">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user16.jpg"
                                />
                                <span className="d-flex align-items-center justify-content-center">
                                  <em className="icon-info" />
                                </span>
                              </div>
                              <div className="familyCard_cnt">
                                <h2>G Father</h2>
                                <p>May 1961 - June 2000</p>
                                <p>-</p>
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ul>
                    <li className="child">
                      <Link>
                        <div className="familyCard">
                          <div className="familyCard_img">
                            <ImageElement
                              className="img-fluid"
                              source="family-tree/user01.jpg"
                            />
                          </div>
                          <div className="familyCard_cnt">
                            <span className="d-flex align-items-center justify-content-center position-absolute">
                              <em className="icon-info" />
                            </span>
                            <h2>Terry D. Williams</h2>
                            <p>May 1951 -Dec 2022</p>
                            <p>Grand Father</p>
                          </div>
                        </div>
                      </Link>
                      <Link>
                        <div className="familyCard">
                          <div className="familyCard_img">
                            <ImageElement
                              className="img-fluid"
                              source="family-tree/user02.jpg"
                            />
                          </div>
                          <div className="familyCard_cnt">
                            <span className="d-flex align-items-center justify-content-center position-absolute">
                              <em className="icon-info" />
                            </span>
                            <h2>Jessica Williams</h2>
                            <p>Dec 1958</p>
                            <p>Grand Mother</p>
                          </div>
                        </div>
                      </Link>
                      <ul>
                        <li className="child">
                          <Link className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user12.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <h2>Lencion Williams </h2>
                                <p>Dec 15, 1968</p>
                                <p>Father</p>
                              </div>
                            </div>
                          </Link>
                          <Link>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user13.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <h2>Jessica Williams </h2>
                                <p>Dec 15, 1968</p>
                                <p>Mother</p>
                              </div>
                            </div>
                          </Link>
                          <ul>
                            <li>
                              <Link>
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user03.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <h2>Carl A. Taylor</h2>
                                    <p>March 10, 1986</p>
                                    <p>Brother</p>
                                  </div>
                                </div>
                              </Link>
                            </li>
                            <li>
                              <Link>
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user06.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <h2>Noemi C. Goodin</h2>
                                    <p>June 15, 1988</p>
                                    <p>Me</p>
                                  </div>
                                </div>
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li className="child child-e x">
                          <Link className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user16.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <h2>Miller Williams</h2>
                                <p>May 1951 -Dec 2022</p>
                                <p>Uncle</p>
                              </div>
                            </div>
                          </Link>
                          <Link>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user15.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <h2>Rose Williams</h2>
                                <p>May 1951 -Dec 2022</p>
                                <p>Aunt</p>
                              </div>
                            </div>
                          </Link>
                          <ul>
                            <li className="child">
                              <Link className="spouse">
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user08.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <h2>Jhon Williams</h2>
                                    <p>May 25, 1988</p>
                                    <p>Cousin's Husband</p>
                                  </div>
                                </div>
                              </Link>
                              <Link>
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user07.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <h2>Jessica Williams</h2>
                                    <p>May 15, 1990</p>
                                    <p>Cousin</p>
                                  </div>
                                </div>
                              </Link>
                              <ul>
                                <li>
                                  <Link>
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user11.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <span className="d-flex align-items-center justify-content-center position-absolute">
                                          <em className="icon-info" />
                                        </span>
                                        <h2>Jery Williams</h2>
                                        <p>May 15, 2010</p>
                                        <p>Nephew</p>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <Link>
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user05.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <h2>Francisco Williams</h2>
                                    <p>July 21, 1993</p>
                                    <p>Cousin</p>
                                  </div>
                                </div>
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <h2>Terry D. Williams</h2>
                                <p>May 1965 -Jan 2000</p>
                                <p>Uncle</p>
                              </div>
                            </div>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
              <div className="controls">
                <button onClick={fitToScreen}>
                  <em className="icon-screenfit" />
                </button>
                <button onClick={zoomIn}>
                  <em className="icon-plus" />
                </button>
                <button onClick={zoomOut}>
                  <em className="icon-minus" />
                </button>
                <button onClick={toggleFullscreen}>
                  <em className="icon-treeexpand" />
                </button>
              </div>
            </div>
          </div>
        </section> */}
        {/* family tree section */}
        {/* theme01 family tree section (use temporarily until theme02 css can be updated) */}
        <section
          className={` familyTree py-80 ${isFullscreen ? "fullWidth" : ""}`}
          id="familytree"
        >
          <div className="familyTreeContainer mx-auto">
            <div className="commonHead text-center">
              <div className="commonHead_sub text-white">
                The Legacy Lives On
              </div>
              <h2 className="commonHead_title text-white">Our Family Tree</h2>
            </div>
            <div className="familyTreeContainer mx-auto">

              <div className="tree">
                <ul className="tree_inner">
                  <li className="parent" >
                    <div className="d-flex align-items-end parentsWrap  justify-content-center">
                      <div className="spouseParents">
                        <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse multipleParents">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul className="multipleParents">
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user27.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user12.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="mainParents">
                        <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse multipleParents">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul className="multipleParents">
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user15.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user16.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <ul>
                      <li className="child">
                        <Link className="spouse">
                          <div className="familyCard">
                            <div className="familyCard_img">
                              {/* <div className="familyCard_tag" >Parents</div> */}
                              <ImageElement
                                className="img-fluid"
                                source="family-tree/user06.jpg"
                              />
                              <span className="d-flex align-items-center justify-content-center position-absolute">
                                <em className="icon-info" />
                              </span>
                            </div>
                            <div className="familyCard_cnt">
                              <h2>Mother</h2>
                              <p>June 15, 1985 </p>
                              <p>Elder Brother</p>
                            </div>
                          </div>
                        </Link>
                        <Link>
                          <div className="heart d-flex align-items-center justify-content-center position-absolute">
                            <em className="icon-heart" />
                          </div>
                          <div className="familyCard">
                            <div className="familyCard_img">
                              <ImageElement
                                className="img-fluid"
                                source="family-tree/user03.jpg"
                              />
                              <span className="d-flex align-items-center justify-content-center position-absolute">
                                <em className="icon-info" />
                              </span>
                            </div>
                            <div className="familyCard_cnt">
                              <h2>Father</h2>
                              <p>May 11, 1988 </p>
                              <p>Brother's Wife</p>
                            </div>
                          </div>
                        </Link>
                        <ul className="multipleParents bottom">
                          <li className="child">
                            <Link className="pe-none">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user09.jpg"
                                  />
                                  {/* <span className="d-flex align-items-center justify-content-center position-absolute">
                                        <em className="icon-info" />
                                      </span> */}
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>Me </h2>
                                  <p>January 11, 2020 </p>
                                  <p>Brother's Son</p>
                                </div>
                              </div>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="controls">
                  <button onClick={fitToScreen}>
                    <em className="icon-screenfit" />
                  </button>
                  <button onClick={zoomIn}>
                    <em className="icon-plus" />
                  </button>
                  <button onClick={zoomOut}>
                    <em className="icon-minus" />
                  </button>
                  <button onClick={toggleFullscreen}>
                    <em className="icon-treeexpand" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonial section STart */}
        <section className="testimonySec light-bg py-80" id="story">
          <Container>
            <div className="commonHead text-center">
              <div className="commonHead_sub">Heartfelt Reflections</div>
              <h2 className="commonHead_title">
                Memories of <br className="d-none d-lg-block" />
                Margarita R. Proffitt
              </h2>
              <div className="d-flex justify-content-center">
                <RippleEffect>
                  <CommonButton
                    variant="danger"
                    extraClassName=" mt-2 mt-md-3 mt-xl-4"
                    onClick={() => setCommentModal(true)}
                  >
                    Share A Story
                  </CommonButton>
                </RippleEffect>
              </div>
            </div>
            <div className="slider testimonySec_inner mx-auto position-relative">
              <Swiper
                // spaceBetween={0}
                slidesPerView={1.1}
                navigation={{
                  nextEl: ".next",
                  prevEl: ".prev",
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 1.1,
                  },
                }}
                centeredSlides="true"
                loop
                effect="coverflow"
                coverflowEffect={{
                  rotate: 0,
                  stretch: 0,
                  depth: 200,
                  modifier: 1,
                  slideShadows: true,
                }}
                modules={[Pagination, Navigation, EffectCoverflow]}
              >
                <SwiperSlide>
                  <div className="testimonySec_card position-relative">
                    <div className=" d-sm-flex align-items-center">
                      <div className="testimonySec_card_img overflow-hidden flex-shrink-0">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme03/testimonial-img.webp"
                          alt="testimonial"
                        />
                      </div>
                      <div className="testimonySec_card_txt text-break">
                        <p className="text-white mb-0">
                          Lorem Ipsum is simply dummy text of the printing and
                          typesetting industry. Lorem Ipsum has been the
                          industry's standard dummy text ever since the 1500s,
                          when an unknown printer took a galley of type and
                          scrambled it to make a type specimen book.
                        </p>
                      </div>
                    </div>
                    <div className="testimonySec_card_author d-flex align-items-center">
                      <ImageElement
                        className="overflow-hidden rounded-circle flex-shrink-0"
                        source="theme03/author.png"
                        alt="testimonial-author"
                      />
                      <div>
                        <h3 className="text-white name">Mike Douglas</h3>
                        <address className="location mb-0 d-flex align-items-center">
                          <em className="icon-location" />
                          San Francisco, CL
                        </address>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className="testimonySec_inner mx-auto position-relative">
                  <div className="testimonySec_card position-relative">
                    <div className=" d-sm-flex align-items-center">
                      <div className="testimonySec_card_img overflow-hidden testimonySec_card_img-pdf flex-shrink-0 flex-column">
                        <ImageElement
                          className="w-100 h-100"
                          source="theme03/pdf-lg.svg"
                          alt="pdf"
                        />
                        <Link className="viewBtn">View PDF</Link>
                      </div>
                      <div className="testimonySec_card_txt text-break">
                        <p className="text-white mb-0">
                          Lorem Ipsum is simply dummy text of the printing and
                          typesetting industry. Lorem Ipsum has been the
                          industry's standard dummy text ever since the 1500s,
                          when an unknown printer took a galley of type and
                          scrambled it to make a type specimen book.
                        </p>
                      </div>
                    </div>
                    <div className="testimonySec_card_author d-flex align-items-center">
                      <ImageElement
                        className="overflow-hidden rounded-circle"
                        source="theme03/author.png"
                        alt="testimonial-author"
                      />
                      <div>
                        <h3 className="text-white name">Mike Douglas</h3>
                        <address className="location mb-0 d-flex align-items-center">
                          <em className="icon-location" />
                          San Francisco, CL
                        </address>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className="testimonySec_inner mx-auto position-relative">
                  <div className="testimonySec_card position-relative">
                    <div className=" d-sm-flex align-items-center">
                      <div className="testimonySec_card_img overflow-hidden flex-shrink-0">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme03/testimonial-img.webp"
                          alt="testimonial"
                        />
                      </div>
                      <div className="testimonySec_card_txt text-break">
                        <p className="text-white mb-0">
                          Lorem Ipsum is simply dummy text of the printing and
                          typesetting industry. Lorem Ipsum has been the
                          industry's standard dummy text ever since the 1500s,
                          when an unknown printer took a galley of type and
                          scrambled it to make a type specimen book.
                        </p>
                      </div>
                    </div>
                    <div className="testimonySec_card_author d-flex align-items-center">
                      <ImageElement
                        className="overflow-hidden rounded-circle"
                        source="theme03/author.png"
                        alt="testimonial-author"
                      />
                      <div>
                        <h3 className="text-white name">Mike Douglas</h3>
                        <address className="location mb-0 d-flex align-items-center">
                          <em className="icon-location" />
                          San Francisco, CL
                        </address>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className="testimonySec_inner mx-auto position-relative">
                  <div className="testimonySec_card position-relative">
                    <div className=" d-sm-flex align-items-center">
                      <div className="testimonySec_card_img overflow-hidden flex-shrink-0">
                        <ImageElement
                          className="object-fit-cover w-100 h-100"
                          source="theme03/testimonial-img.webp"
                          alt="testimonial"
                        />
                      </div>
                      <div className="testimonySec_card_txt text-break">
                        <p className="text-white mb-0">
                          Lorem Ipsum is simply dummy text of the printing and
                          typesetting industry. Lorem Ipsum has been the
                          industry's standard dummy text ever since the 1500s,
                          when an unknown printer took a galley of type and
                          scrambled it to make a type specimen book.
                        </p>
                      </div>
                    </div>
                    <div className="testimonySec_card_author d-flex align-items-center">
                      <ImageElement
                        className="overflow-hidden rounded-circle"
                        source="theme03/author.png"
                        alt="testimonial-author"
                      />
                      <div>
                        <h3 className="text-white name">Mike Douglas</h3>
                        <address className="location mb-0 d-flex align-items-center">
                          <em className="icon-location" />
                          San Francisco, CL
                        </address>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div className="slider_btn">
                <Button type="button" className="prev">
                  <em className="icon-left-arrow" />
                </Button>
                <Button type="button" className="next">
                  <em className="icon-right-arrow" />
                </Button>
              </div>
            </div>
          </Container>
        </section>
        {/* Testimonial section End */}

        {/* Timeline section Start */}
        <section className="timelineSec py-80" id="timeline">
          <Container>
            <div className="d-flex">
              <div className="commonHead mb-0 d-flex">
                <div className="commonHead_img rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
                  <ImageElement
                    className="img-fluid"
                    source="theme03/timeline-img.png"
                    alt="timeline"
                  />
                </div>
                <div>
                  <div className="commonHead_sub mb-xxl-3 mb-0">
                    Narratives of a Lifetime
                  </div>
                  <h2 className="commonHead_title">
                    A Timeline of Meaningful{" "}
                    <br className="d-none d-sm-block" />
                    Memories
                  </h2>
                </div>
              </div>
            </div>
            <ul className="timelineSec_list list-unstyled position-relative pb-sm-4 mb-0">
              {/* Timeline item */}
              <li className="timelineSec_item d-flex pb-0">
                <div className="timelineSec_time flex-shrink-0">
                  <div className="year text-center position-relative z-1">
                    2024
                  </div>
                </div>
              </li>
              {/* Timeline item */}
              <li className="timelineSec_item d-flex">
                <div className="timelineSec_time flex-shrink-0">
                  <div className="date d-flex align-items-center flex-column justify-content-center position-relative z-1">
                    Jan<span>20</span>
                  </div>
                </div>
                <div className="timelineSec_box d-md-flex align-items-center">
                  <div className="timelineSec_box_img flex-shrink-0 overflow-hidden">
                    <ImageElement
                      className="h-100 w-100 object-fit-cover"
                      source="theme03/timeline01.webp"
                      alt="timeline-img"
                    />
                  </div>
                  <div className="timelineSec_box_txt">
                    <h3 className="title">
                      The standard Lorem Ipsum passage, used since the 1500s
                    </h3>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer.
                    </p>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </div>
                </div>
              </li>
              {/* Timeline item */}
              <li className="timelineSec_item d-flex">
                <div className="timelineSec_time flex-shrink-0 ">
                  <div className="date d-flex align-items-center flex-column justify-content-center position-relative z-1">
                    Jan<span>15</span>
                  </div>
                </div>
                <div className="timelineSec_box d-md-flex align-items-center">
                  <div className="timelineSec_box_img flex-shrink-0 overflow-hidden">
                    <ImageElement
                      className="h-100 w-100 object-fit-cover"
                      source="theme03/timeline02.webp"
                      alt="timeline-img"
                    />
                  </div>
                  <div className="timelineSec_box_txt">
                    <h3 className="title">
                      The standard Lorem Ipsum passage, used since the 1500s
                    </h3>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer.
                    </p>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </div>
                </div>
              </li>
              {/* Timeline item */}
              <li className="timelineSec_item d-flex pb-0">
                <div className="timelineSec_time flex-shrink-0">
                  <div className="year text-center position-relative z-1">
                    2023
                  </div>
                </div>
              </li>
              {/* Timeline item */}
              <li className="timelineSec_item d-flex">
                <div className="timelineSec_time flex-shrink-0 ">
                  <div className="date d-flex align-items-center flex-column justify-content-center position-relative z-1">
                    OCT<span>25</span>
                  </div>
                </div>
                <div className="timelineSec_box d-md-flex align-items-center">
                  <div className="timelineSec_box_img flex-shrink-0 overflow-hidden">
                    <ImageElement
                      className="h-100 w-100 object-fit-cover"
                      source="theme03/timeline03.webp"
                      alt="timeline-img"
                    />
                  </div>
                  <div className="timelineSec_box_txt">
                    <h3 className="title">
                      The standard Lorem Ipsum passage, used since the 1500s
                    </h3>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer.
                    </p>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </div>
                </div>
              </li>
              {/* Timeline item */}
              <li className="timelineSec_item d-flex">
                <div className="timelineSec_time flex-shrink-0 ">
                  <div className="date d-flex align-items-center flex-column justify-content-center position-relative z-1">
                    OCT<span>15</span>
                  </div>
                </div>
                <div className="timelineSec_box d-md-flex align-items-center">
                  <div className="timelineSec_box_img flex-shrink-0 overflow-hidden">
                    <ImageElement
                      className="h-100 w-100 object-fit-cover"
                      source="theme03/timeline04.webp"
                      alt="timeline-img"
                    />
                  </div>
                  <div className="timelineSec_box_txt">
                    <h3 className="title">
                      The standard Lorem Ipsum passage, used since the 1500s
                    </h3>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer.
                    </p>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </div>
                </div>
              </li>
              {/* Timeline item */}
              <li className="timelineSec_item d-flex">
                <div className="timelineSec_time flex-shrink-0 ">
                  <div className="date d-flex align-items-center flex-column justify-content-center position-relative z-1">
                    OCT<span>05</span>
                  </div>
                </div>
                <div className="timelineSec_box d-md-flex align-items-center">
                  <div className="timelineSec_box_img flex-shrink-0 overflow-hidden">
                    <ImageElement
                      className="h-100 w-100 object-fit-cover"
                      source="theme03/timeline05.webp"
                      alt="timeline-img"
                    />
                  </div>
                  <div className="timelineSec_box_txt">
                    <h3 className="title">
                      The standard Lorem Ipsum passage, used since the 1500s
                    </h3>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer.
                    </p>
                    <p className="mb-0">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <Row className="position-relative justify-content-end g-0 d-none d-sm-flex">
              <Col xxl={6} sm={5}>
                <span className="timelineSec_bottom" />
                <ImageElement
                  className="img-fluid ms-auto d-block"
                  source="theme03/group-img.webp"
                  alt="timeline"
                />
              </Col>
            </Row>
          </Container>
        </section>
        {/* Timeline section End */}
      </main>
      <ModalComponent
        show={shareModal}
        size="md"
        title="Share Biography"
        closeButton="true"
        modalExtraClass="sharebiography"
        extraTitleClassName="sharebiography_title"
        onHandleCancel={handleCloseModal}
      >
        <div className="sharebiography_body">
          <form>
            <div className="d-flex align-items-end lh-1">
              <div className="form-group mb-0">
                <label className="form-label lh-sm">Copy Url</label>
                <input
                  id="url"
                  name="url"
                  className="form-control"
                  placeholder="Enter Url"
                  type="email"
                />
              </div>
              <RippleEffect>
                <Button variant="danger">Copy Link</Button>
              </RippleEffect>
            </div>
          </form>
        </div>
        <div className="sharebiography_footer">
          <h3>Share this link via</h3>
          <ul className="d-flex list-unstyled mb-0">
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
                aria-label="instagram"
              >
                <em className="icon-instagram" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
                aria-label="twitter"
              >
                <em className="icon-twitter" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
                aria-label="youtube"
              >
                <em className="icon-youtube" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
                aria-label="facebook"
              >
                <em className="icon-facebook" />
              </Link>
            </li>
          </ul>
        </div>
      </ModalComponent>
      {/* Image modal slider */}
      <ModalComponent
        size="md"
        show={showModal1}
        onHandleCancel={handleCloseModal1}
        extraClassName="imageSlider"
        backdropClassName="sliderBack"
        pagination={{ clickable: true }}
        closeVariant="white"
      >
        <div className="slider">
          <h2 className="text-center">The Early Years</h2>
          <Swiper
            spaceBetween={20}
            slidesPerView={1.4}
            centeredSlides
            autoplay={{
              delay: 2500,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }}
            loop
            pagination={{
              clickable: true,
            }}
            navigation={{
              nextEl: ".next",
              prevEl: ".prev",
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              575: {
                slidesPerView: 1.3,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 1.4,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 1.8,
                spaceBetween: 20,
              },
            }}
            modules={[Autoplay, Pagination, Navigation]}
          >
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>The Early Years</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Footprints of Time</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Milestones Unfold</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-03.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Family Bonds</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Friendship Chronicles</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Love & Relationships</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-03.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Special Occasions</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Home Sweet Home</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Home Sweet Home</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                {/* <h2>Home Sweet Home</h2> */}
                <h3>Innocence Captured: A Glimpse of Babyhood</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
          </Swiper>
          <div className="slider_btn">
            <Button type="button" className="prev">
              <em className="icon-left-arrow" />
            </Button>
            <Button type="button" className="next">
              <em className="icon-right-arrow" />
            </Button>
          </div>
        </div>
      </ModalComponent>

      {/* Memories video modal */}
      <ModalComponent
        show={showVideoModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalVideo}
      >
        <form>
          <div className="videoModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light"
                    onClick={handleSelectAllVideo}
                  >
                    {selectAllCheckedVideo ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {videoMemories.map((el, index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxesVideo[index]}
                    onChange={() => handleCheckboxChangeVideo(index)}
                  >
                    <div className="videoCard position-relative">
                      <ImageElement source={el.thumbnail} alt="video" />
                      <div className="videoCard_cnt d-flex justify-content-between align-items-center position-absolute w-100">
                        <h2 className="mb-0">{el.name}</h2>
                        <span className="d-inline-block">{el.duration}</span>
                      </div>
                      <Link
                        to="#!"
                        className="videoCard_playbtn position-absolute"
                        onClick={() => handleVideoFullShow(true)}
                      >
                        <div className="videoCard_playbtn_inner d-flex align-items-center justify-content-center">
                          <em className="icon-video" />
                        </div>
                      </Link>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories audio modal */}
      <ModalComponent
        show={showAudioModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="audioModal"
        extraTitleClassName="audioModal_title"
        onHandleCancel={handleCloseModalAudio}
      >
        <form>
          <div className="audioModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light"
                    onClick={handleSelectAllAudio}
                  >
                    {selectAllCheckedAudio ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {audioMemories.map((el, index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxesAudio[index]}
                    onChange={() => handleCheckboxChangeAudio(index)}
                  >
                    <div className="audioCard position-relative">
                      <div className="d-flex align-items-center">
                        <Link
                          to="#!"
                          className="audioCard_icon d-flex justify-content-center align-items-center"
                        >
                          <em className="icon-video" />
                        </Link>
                        <div className="w-100">
                          <h3>{el.name}</h3>
                          <div className="audioCard_img d-flex align-items-center">
                            <ImageElement
                              source="audio.svg"
                              alt="audio"
                              className="w-100"
                            />
                            <span>{el.duration}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories video Full modal */}
      <ModalComponent
        show={showVideoFullModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalVideoFull}
      >
        <form>
          <div className="videoModal_body">
            <Row>
              <Col sm={12}>
                <div className="videoCard-full position-relative overflow-hidden">
                  <ImageElement
                    source="modal-video-01.webp"
                    alt="video"
                    className="h-100 w-100 object-fit-cover"
                  />
                  <Link to="#!" className="videoCard_playbtn position-absolute">
                    <div className="videoCard_playbtn_inner d-flex align-items-center justify-content-center">
                      <em className="icon-video" />
                    </div>
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories Pdf modal */}
      <ModalComponent
        show={showPdfModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalPdf}
      >
        <form>
          <div className="videoModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button className="btn btn-light" onClick={handleSelectAll}>
                    {selectAllChecked ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {[0, 1, 2, 3, 4, 5].map((index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxes[index]}
                    onChange={() => handleCheckboxChange(index)}
                  >
                    <div className="pdfCard position-relative d-flex align-items-center justify-content-center flex-column">
                      <ImageElement
                        source="theme03/pdf-white.webp"
                        alt="logo"
                      />
                      <Link className="viewBtn">View PDF</Link>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Add Comment Modal */}
      <ModalComponent
        show={commentModal}
        size="md"
        title="Write Comment"
        closeButton="true"
        modalExtraClass="commentModel"
        extraTitleClassName="commentModel_title"
        onHandleCancel={handleCloseModalComment}
      >
        <div className="commentModel_body">
          <form>
            <div className="d-sm-flex w-100">
              <div className="commentModel_left">
                <h2>Upload Picture/ pdf</h2>
                <div className="customUpload customUpload-icon customUpload-w100">
                  <Upload listType="picture-card" className="avatar-uploader">
                    <div>
                      <em className="icon-upload" />
                      <span className="d-block">Upload Picture/ Pdf</span>
                    </div>
                  </Upload>
                </div>
              </div>
              <div className="commentModel_right w-100">
                <h2>Comment</h2>
                <Row className="g-20">
                  <Col xs={12}>
                    <div className="form-group">
                      <textarea
                        className="form-control form-control-textarea w-100"
                        placeholder="Type Here"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="commentModel_btn d-flex justify-content-end">
                  <RippleEffect>
                    <Button
                      className="btn btn-light"
                      onClick={() => setCommentModal(false)}
                    >
                      Close
                    </Button>
                  </RippleEffect>
                  <RippleEffect>
                    <Button
                      className="btn btn-danger"
                      onClick={() => setCommentModal(false)}
                    >
                      Send
                    </Button>
                  </RippleEffect>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ModalComponent>
      {/* Report modal */}
      <ModalComponent
        show={showReportModal}
        size="md"
        title="Report Biography"
        closeButton="true"
        modalExtraClass="reportModal"
        extraTitleClassName="reportModal_title"
        onHandleCancel={handleCloseModalReport}
      >
        <form>
          <div className="reportModal_body">
            <h2>Are you sure to want to report this?</h2>
            <div className="form-group">
              <Select
                placeholder="Select Category"
                options={[
                  { value: "Category01", label: "Category01" },
                  { value: "Category02", label: "Category02" },
                  { value: "Category03", label: "Category03" },
                ]}
              />
            </div>
            <div className="form-group mb-0">
              <label className="form-label lh-sm">Reason for Report</label>
              <textarea
                className="form-control form-control-textarea"
                placeholder="Type Here"
              />
            </div>
          </div>
          <div className="reportModal_footer text-end">
            <RippleEffect>
              <Button
                className="btn btn-light"
                onClick={() => setReportModal(false)}
              >
                Close
              </Button>
            </RippleEffect>
            <RippleEffect>
              <Button
                className="btn btn-danger"
                onClick={() => setReportModal(false)}
              >
                Send Report
              </Button>
            </RippleEffect>
          </div>
        </form>
      </ModalComponent>
    </>
  );
}

export default Theme03Static;
